import React from 'react';
import { Result } from 'antd';

const NotFound = () => (
  <Result
    status="404"
    title="404"
    subTitle="Omlouváme se, stránka kretou chcete navštívit neexistuje."
  />
);

export default NotFound;
